(function () {
hubspot.define('hubspot.embedding.apps.dialog', ['jQuery', 'q/js/lib/defer', 'vex', 'hubspot.embedding.common', 'hubspot.embedding.host'], function($, defer, vex, common, embedHost) {
  var openDialog;
  openDialog = function(appElId, appChannelId, url, css, appParams, origin, vexOptions) {
    var $vexContent, appLifetime, embeddedAppContent, handleAppClose, handleAppOpen, template, vexId;
    if (css == null) {
      css = {};
    }
    if (vexOptions == null) {
      vexOptions = {};
    }
    template = jade.templates.embeddedAppIframe;
    embeddedAppContent = template({
      url: url,
      id: appElId,
      extraStyles: 'border:none; border-radius: 5px;'
    });
    appLifetime = defer();
    vexId = null;
    handleAppOpen = function() {
      var innerWindow;
      innerWindow = $("#" + appElId)[0].contentWindow;
      return embedHost.waitForAppReady({
        targetWindow: innerWindow,
        channel: appChannelId,
        origin: origin
      }).then(function() {
        vex.hideLoading();
        return embedHost.startApp({
          channel: appChannelId,
          params: appParams
        });
      }).then(function(messageInfo) {
        appLifetime.resolve(messageInfo.message.data.params);
        return vex.closeByID(vexId);
      }).done();
    };
    handleAppClose = function() {
      appLifetime.resolve({
        closeEvent: 'cancel'
      });
      return vex.hideLoading();
    };
    vex.showLoading();
    _(vexOptions).extend({
      content: embeddedAppContent,
      afterOpen: handleAppOpen,
      afterClose: handleAppClose
    });
    if (vex.defaultOptions.contentCSS != null) {
      vexOptions.contentCSS = css;
    } else {
      vexOptions.css = css;
    }
    $vexContent = vex.open(vexOptions);
    vexId = $vexContent.data().vex.id;
    return appLifetime.promise;
  };
  return {
    openDialog: openDialog
  };
});
}());

(function () {
hubspot.define('hubspot.embedding.apps.file_manager', ['jQuery', '_', 'q/js/lib/defer', 'enviro', 'hubspot.embedding.host', 'hubspot.embedding.common', 'hubspot.embedding.apps.dialog'], function($, _, defer, Env, embedHost, embed, embedDialog) {
  var channelId, getAppLocation, openDocumentPicker, openFilePicker, openForDesignManager, openImagePicker;
  channelId = 'file_manager';
  getAppLocation = function(options) {
    var debugParam, env, origin, params, portalId, url;
    if (options == null) {
      options = {};
    }
    params = options.query || {};
    params.app = options.app || 'dialog';
    debugParam = embed.hsDebugParam();
    if (debugParam != null) {
      params.hsDebug = debugParam;
    }
    portalId = hubspot.portal.id;
    env = Env.getShort('file_manager');
    origin = {
      local: window.location.origin,
      qa: 'https://app.hubspotqa.com',
      prod: 'https://app.hubspot.com'
    }[env];
    url = origin + "/file-manager/" + portalId + "?" + ($.param(params));
    return {
      origin: origin,
      url: url
    };
  };
  openFilePicker = function(options) {
    var appChannelId, appElId, appLocation, appParams, css, dialogCss, origin, promise, topBottomSpacing, url, vexOptions, vexWidth;
    if (options == null) {
      options = {};
    }
    if (options.pickerType == null) {
      options.pickerType = 'file';
    }
    vexWidth = 856;
    topBottomSpacing = 60;
    dialogCss = {
      cssText: "width: " + vexWidth + "px; min-height: 450px; left: 50%; margin-left: -" + (parseInt(vexWidth / 2, 10)) + "px; top: " + topBottomSpacing + "px; bottom: " + topBottomSpacing + "px; display: block; position: fixed"
    };
    options.dialogHeight = (Math.floor($(window).height() - (topBottomSpacing * 2))) + "px";
    appLocation = getAppLocation();
    promise = embedDialog.openDialog(appElId = 'file_manager_dialog', appChannelId = channelId, url = appLocation.url, css = dialogCss, appParams = _.omit(options, 'complete'), origin = appLocation.origin, vexOptions = options.vexOptions || {});
    if (options.complete) {
      promise.done(function(appDoneArgs) {
        if (appDoneArgs) {
          return options.complete.apply(this, appDoneArgs);
        }
      });
    }
    return promise;
  };
  openImagePicker = function(options) {
    if (options == null) {
      options = {};
    }
    options.pickerType = 'image';
    return openFilePicker(options);
  };
  openDocumentPicker = function(options) {
    if (options == null) {
      options = {};
    }
    options.pickerType = 'document';
    return openFilePicker(options);
  };
  openForDesignManager = function(options) {
    var $iframe, appInfo, appLifetime, appLocation, innerWindow, ref;
    if (options == null) {
      options = {};
    }
    _(options).defaults({
      app: 'designManager'
    });
    appLocation = getAppLocation(options);
    appLifetime = defer();
    $iframe = $((ref = options.iframeSelector) != null ? ref : '.file-manager-iframe');
    $iframe.attr('src', appLocation.url);
    innerWindow = $iframe[0].contentWindow;
    embedHost.waitForAppReady({
      targetWindow: innerWindow,
      channel: channelId,
      origin: appLocation.origin,
      appLifetime: appLifetime
    }).then(function() {
      var ref1;
      return embedHost.startApp({
        channel: channelId,
        params: (ref1 = options.params) != null ? ref1 : {}
      });
    }).done();
    return appInfo = {
      targetWindow: innerWindow,
      channel: channelId,
      destination: appLocation.origin,
      promise: appLifetime.promise
    };
  };
  return {
    openFilePicker: openFilePicker,
    openImagePicker: openImagePicker,
    openDocumentPicker: openDocumentPicker,
    openForDesignManager: openForDesignManager
  };
});
}());

